import styled from 'styled-components';

import Icon from '@klv/atoms/icon';
import Button from '@klv/atoms/button';
import Typography from '@klaviyo-mkt/gatsby-components/atoms/typography';

export const CloseButton = styled.button`
  appearance: none;
  background: none;
  border: none;
  cursor: pointer;
  outline: none;
  padding: 0.3rem;
  position: absolute;
  top: 1.2rem;
  right: 1.2rem;
`;

export const StyledIcon = styled(Icon)``;

export const StyledButton = styled(Button)`
  display: inline-flex;
  gap: 0.6rem;
  align-items: center;
  justify-content: center;

  ${StyledIcon} {
    fill: currentColor;
  }
`;

export const Headline = styled(Typography)`
  display: flex;
  gap: 1.6rem;
`;

export const Subhead = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 2rem;
`;

export const Actions = styled.div`
  display: flex;
  gap: 1.6rem;
`;

export const VoteInfo = styled(Typography)``;

export const CheckboxContainer = styled.div`
  margin-bottom: 2.5rem;
`;

export const StyledArticleVoteForm = styled.div<{ hasFeedback: boolean; }>`
  bottom: 1.6rem;
  color: ${({ theme }) => theme.articleVoteForm.color};
  display: flex;
  gap: 3.2rem;
  flex-direction: column;
  padding-top: 4rem;
  width: 100%;

  ${({ hasFeedback }) => `
    ${hasFeedback ? 'gap: 0.8rem;' : ''}
  `}

  a {
    color: ${({ theme }) => theme.colors.charcoal};

    &:hover {
      color: ${({ theme }) => theme.colors.charcoal};
    }
  }
`;

export const feedbackThanks = styled(Typography)`
  margin-bottom: 1.6rem;
`;

export default StyledArticleVoteForm;
